import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const MultiCarouselBrand = ({ item, index }) => (

    <div key={item.name + index} className="brand-block__wrapper">
        <a className="brand-block__link" href={item.url}>
            {item.imageData.src ? (
                <Fragment>
                    <img itemProp="image" alt={item.imageData.alt} src={item.imageData.src} height={item.imageData.height} width={item.imageData.width}  className="brand-block__image"></img>
                </Fragment>
            ) : (<span className="product__image--missing">{translate('product.noproductimage')}</span>)}
        </a>
    </div>
)
export default MultiCarouselBrand;
